// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3VUMZ","column":"style_column__2TzOK","row":"style_row__3n5lZ"};